export const userActionTypes = {
    SET_LOGGED_USER: 'SET_LOGGED_USER',
    SET_USER_LIST: 'SET_USER_LIST',
};

const userReducer = (state, action) => {
    switch (action.type) {
        case userActionTypes.SET_LOGGED_USER:
            return {
                ...state,
                loggedUserData: action.loggedUserData
            };

        case userActionTypes.SET_USER_LIST:
            return {
                ...state,
                userList: action.userList
            };

        default:
            return state;
    }
};

export default userReducer;